define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaEquipMaintTypeDomain = void 0;
    class WaEquipMaintTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaEquipMaintTypeDomain.None, value: "None" },
                    { key: WaEquipMaintTypeDomain.Routine, value: "Routine" },
                    { key: WaEquipMaintTypeDomain.Major, value: "Major" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaEquipMaintTypeDomain.None] = 0;
                this.KeyIndex[WaEquipMaintTypeDomain.Routine] = 1;
                this.KeyIndex[WaEquipMaintTypeDomain.Major] = 2;
                this.ValueIndex = {};
                this.ValueIndex["None"] = 0;
                this.ValueIndex["Routine"] = 1;
                this.ValueIndex["Major"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaEquipMaintTypeDomain = WaEquipMaintTypeDomain;
    Object.defineProperty(WaEquipMaintTypeDomain, "None", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaEquipMaintTypeDomain, "Routine", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaEquipMaintTypeDomain, "Major", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaEquipMaintTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
